import { Component } from '@angular/core';
import { PropertiesComponent } from '../properties.component';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-bookmarked',
  imports: [PropertiesComponent, BreadcrumbComponent],
  templateUrl: './bookmarked.component.html',
  styleUrl: './bookmarked.component.css',
})
export class BookmarkedComponent {
  readonly breadcrumdItems: MenuItem[] = [
    {
      label: 'Properties',
      routerLink: '/home/properties',
    },
    {
      label: 'Bookmarks',
    },
  ];
}
